<template>
    <div class="sms-code">
        <v-input v-model.trim="smscode" :placeholder="$t('请输入')" class="sms-code-input" />
        <v-button :disabled="disabled || codeCountDownIng" class="sms-code-button" @click="getCode">
        {{ sendCodeText }}
        </v-button>
    </div>
</template>
<script>
const COUNT_DOWN_INIT = 60;
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            smscode: '',
            countdown: COUNT_DOWN_INIT,
            countdownTimer: null,
            sendCodeText: this.$t('获取验证码'),
            codeCountDownIng: false,
        };
    },
    watch: {
        smscode(val) {
            this.$emit('change', val);
        },
    },
    methods: {
        customFn(res) {
            this.codeCountDownIng = false;
            this.$message.error(res.message || this.$t('网络故障，请稍后再试'));
        },
        getCode() {
            this.$emit('getSmsCode');
        },
        getSmsCode(params) {
            this.codeCountDownIng = true;
            this.$ajax.post('/mng/account/contacts/genExternalPhoneVerifyCode', params, {
                customFn: this.customFn,
            }).then(() => {
                this.codeCountdown();
            });
        },
        clearCountdownTimer() {
            clearInterval(this.countdownTimer);
        },
        codeCountdown() {
            let wait = 60;
            const waitText = 's';
            this.sendCodeText = wait + waitText;
            this.timer = setInterval(() => {
                // eslint-disable-next-line no-plusplus
                wait--;
                if (wait < 0) {
                    clearInterval(this.timer);
                    this.codeCountDownIng = false;
                    this.sendCodeText = this.$t('获取验证码');
                } else {
                    this.sendCodeText = wait + waitText;
                }
            }, 1000);
            setTimeout(() => {
                this.sendCodeSuccess = true;
            }, 0);
        },
    },
};
</script>
<style lang="less" scoped>
.sms-code {
    display: inline-flex;
    width: 100%;
    gap: var(--spacing-base);
    justify-content: space-between;
    align-items: end;

    &-input {
        flex: 1;
    }

    &-button {
        min-width: 120px;
    }
}
</style>
